import { z } from 'zod';

/**
 * Validaciones espejo del backend (`CreateCatalogoProyectoItemDto` y
 * `UpdateCatalogoProyectoItemDto`, NestJS class-validator):
 *
 *  - `nombre`: requerido, 1–120 caracteres, trim.
 *  - `descripcion`: opcional, máx 500. `null` o cadena vacía limpian el campo
 *    en update.
 */

const nombre = z
  .string()
  .trim()
  .min(1, 'El nombre es obligatorio.')
  .max(120, 'Máximo 120 caracteres.');

const descripcionOpt = z.string().trim().max(500, 'Máximo 500 caracteres.').optional();

export const crearCatalogoItemSchema = z.object({
  nombre,
  descripcion: descripcionOpt,
});

export const actualizarCatalogoItemSchema = z.object({
  nombre: nombre.optional(),
  // `null` se interpreta como limpiar la descripción.
  descripcion: z.union([descripcionOpt, z.null()]),
});

export const filtrosCatalogoSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
  search: z.string().trim().optional(),
  includeInactive: z.coerce.boolean().optional(),
});

export type CrearCatalogoItemInput = z.infer<typeof crearCatalogoItemSchema>;
export type ActualizarCatalogoItemInput = z.infer<typeof actualizarCatalogoItemSchema>;
export type FiltrosCatalogoInput = z.infer<typeof filtrosCatalogoSchema>;
